import React, { useMemo, useState, type FC } from 'react'
import type { IconBaseProps } from 'react-icons'
import {
  MdChevronRight as MdChevronRightRaw,
  MdAdd as MdAddRaw,
  MdMusicNote as MdMusicNoteRaw,
  MdArrowBack as MdArrowBackRaw,
  MdMoreHoriz as MdMoreHorizRaw,
  MdSearch as MdSearchRaw,
} from 'react-icons/md'
import './Orders.scss'
import CreateOrderPlaylistView from '../../components/CreateOrderPlaylistView/CreateOrderPlaylistView'
import SearchInput from '../../components/SearchInput/SearchInput'

type OrderStatus = 'processing' | 'delivered'

type OrderItem = {
  id: string
  dateLabel: string
  status: OrderStatus
}

const statusLabel: Record<OrderStatus, string> = {
  processing: 'Processing your order',
  delivered: 'Order delivered',
}

/** FIX TS2786 (как в Settings) */
const MdChevronRight = MdChevronRightRaw as unknown as FC<IconBaseProps>
const MdAdd = MdAddRaw as unknown as FC<IconBaseProps>
const MdMusicNote = MdMusicNoteRaw as unknown as FC<IconBaseProps>
const MdArrowBack = MdArrowBackRaw as unknown as FC<IconBaseProps>
const MdMoreHoriz = MdMoreHorizRaw as unknown as FC<IconBaseProps>
const MdSearch = MdSearchRaw as unknown as FC<IconBaseProps>

export default function Orders() {
  const [searchValue, setSearchValue] = useState('')
  const [create, setCreate] = useState(false)

  const orders: OrderItem[] = useMemo(
    () => [
      { id: 'p1', dateLabel: '10-03-2025 11:30 AM', status: 'processing' },
      { id: 'p2', dateLabel: '10-03-2025 11:30 AM', status: 'processing' },
      { id: 'p3', dateLabel: '10-03-2025 11:30 AM', status: 'processing' },

      { id: 'c1', dateLabel: '10-03-2025 11:30 AM', status: 'delivered' },
      { id: 'c2', dateLabel: '10-03-2025 11:30 AM', status: 'delivered' },
      { id: 'c3', dateLabel: '10-03-2025 11:30 AM', status: 'delivered' },
    ],
    [],
  )

  const pending = useMemo(() => orders.filter((o) => o.status === 'processing'), [orders])
  const completed = useMemo(
    () => orders.filter((o) => o.status === 'delivered'),
    [orders],
  )

  const onCreateOrder = () => setCreate(true)
  const onOpenOrder = (id: string) => {
    void id
  }

  return (
    <div className="ordersPage">
      {create ? (
        <CreateOrderPlaylistView onBack={() => setCreate(false)} />
      ) : (
        <>
          {/* ✅ Mobile top bar (как на макете) */}
          <div className="ordersMobileBar">
            <button type="button" className="ordersMobileIconBtn" aria-label="Back">
              <MdArrowBack size={22} />
            </button>

            <div className="ordersMobileTitle">Orders</div>

            <button type="button" className="ordersMobileIconBtn" aria-label="Menu">
              <MdMoreHoriz size={22} />
            </button>
          </div>

          <div className="ordersInner">
            <SearchInput />

            <h1 style={{ marginTop: '100px' }} className="ordersTitle">
              Orders
            </h1>

            {/* Create order */}
            <div className="ordersSection">
              <div className="ordersSectionLabel">Create order</div>

              <button type="button" className="ordersCreateCard" onClick={onCreateOrder}>
                <div className="ordersCreateText">
                  <div className="ordersCreateTitle">Order playlist</div>
                  <div className="ordersCreateSub">Playlist</div>
                </div>

                <span className="ordersCreatePlus" aria-hidden="true">
                  <MdAdd size={20} />
                </span>
              </button>
            </div>

            {/* Pending */}
            <div className="ordersSection">
              <div className="ordersSectionLabel">Pending orders</div>

              <div className="ordersGrid">
                {pending.map((o) => (
                  <button
                    key={o.id}
                    type="button"
                    className="orderCard"
                    onClick={() => onOpenOrder(o.id)}
                  >
                    <div className="orderCardIcon">
                      <MdMusicNote size={22} />
                    </div>

                    <div className="orderCardBody">
                      <div className="orderCardDate">{o.dateLabel}</div>
                      <div className="orderCardStatus">{statusLabel[o.status]}</div>
                    </div>

                    <div className="orderCardChevron" aria-hidden="true">
                      <MdChevronRight size={22} />
                    </div>
                  </button>
                ))}
              </div>
            </div>

            {/* Completed */}
            <div className="ordersSection">
              <div className="ordersSectionLabel">Completed orders</div>

              <div className="ordersGrid">
                {completed.map((o) => (
                  <button
                    key={o.id}
                    type="button"
                    className="orderCard isCompleted"
                    onClick={() => onOpenOrder(o.id)}
                  >
                    <div className="orderCardIcon">
                      <MdMusicNote size={22} />
                    </div>

                    <div className="orderCardBody">
                      <div className="orderCardDate">{o.dateLabel}</div>
                      <div className="orderCardStatus">{statusLabel[o.status]}</div>
                    </div>

                    <div className="orderCardChevron" aria-hidden="true">
                      <MdChevronRight size={22} />
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
